import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import cookie from 'react-cookies'
import { notify } from 'react-notify-toast'
import { trackPromise } from 'react-promise-tracker'
import { loadStripe } from '@stripe/stripe-js'

import SelectSubscriptionPlanScreen from './SelectSubscriptionPlanScreen'
import SelectPromoSubscriptionPlanScreen from './SelectPromoSubscriptionPlanScreen'
import {
  getUserData,
  patchUserData,
  createUserPaymentSession,
  checkUserSubscriptionStatus,
  getStripePaidContent,
  getUserStripeBoughtPackages,
  getPromoInfo,
} from '../../Api/backendApi'

import SelectSub from './RED_SelectSub'

class SelectSubscriptionPlanScreenContainer extends Component {
  constructor(props) {
    super(props)

    this.state = {
      user: {},
      userIsLogged: cookie.load('accessToken') ? true : false,
      isUserClickedButton: false,
      isUserCheckedLegalRegulationsChheckbox: false,
      isUserReminded: false,
      mode: this.props.match.params.planName,
      paidContent: [],
      userBoughtPackages: [],
      productCorrectPrice: null,
      stripeProductName: '',
      showModal: false,
      isPromoMode:
        this.props.location.state && this.props.location.state.promo
          ? this.props.location.state.promo
          : false,
    }
  }

  componentDidMount = async () => {
    if (!this.state.userIsLogged) {
      this.props.history.push('/zaloguj')
    }
    const userData = await trackPromise(getUserData())
    await trackPromise(this.getPaidContent())
    await trackPromise(this.getUserSubInfo())
    await this.redirectIfSubscriber()
    // await this.setCorrectprice()
    await this.getPromoInfos()

    this.setState({
      user: userData,
    })
  }

  componentDidUpdate = (prevProps, prevState) => {
    if (prevState.mode != this.state.mode) {
      this.setCorrectprice()
    }

    // detect if user changed manually url and it doesnt match current url, than reload page to obtain correct new data

    // if (prevProps.location.pathname != window.location.pathname) {
    //   window.location.reload()
    // }
  }
  getPromoInfos = async () => {
    const promoInfo = await getPromoInfo()

    if (promoInfo) {
      this.setState({
        promoInfo: promoInfo,
      })
    }
  }

  redirectIfSubscriber = () => {
    if (
      this.state.user.has_subscription &&
      this.checkIfUserHasPaidContent() &&
      !this.props.location.prolongSub
    ) {
      this.props.history.push('/')
    }
  }

  logout = () => {
    cookie.remove('accessToken', { path: '/' })
    cookie.remove('refreshToken', { path: '/' })
    cookie.remove('userDemoMode')
    setTimeout(() => {
      this.props.history.push('/')
    }, 550)
  }

  getUserSubInfo = async () => {
    let subInfo = await checkUserSubscriptionStatus()

    this.setState({
      subInfo: subInfo,
    })
  }

  checkIfUserHasPaidContent = () => {
    let hasPackage = false
    const paidContent = ['Szpagat Turecki']

    this.state.userBoughtPackages.forEach((userPackage) => {
      if (paidContent.includes(userPackage.product_name)) {
        hasPackage = true
      }
    })

    return hasPackage
  }

  getPaidContent = async () => {
    let content = await getStripePaidContent()
    let userBoughtPackages = await getUserStripeBoughtPackages()

    this.setState({
      paidContent: content,
      userBoughtPackages: userBoughtPackages,
    })
  }

  // setCorrectprice = () => {
  //   const { mode, paidContent } = this.state
  //   let discountedprice = 0
  //   let standardprice = 0

  //   if (mode != 'sub' && mode != 'prolong') {
  //     paidContent &&
  //       paidContent.forEach((content) => {
  //         if (content.name == mode) {
  //           if (
  //             content &&
  //             content.prices[0] &&
  //             content.prices[0].unit_amount &&
  //             content.prices[0].unit_amount > content.prices[1].unit_amount
  //           ) {
  //             discountedprice = content.prices[1].unit_amount
  //             standardprice = content.prices[0].unit_amount
  //           } else {
  //             discountedprice = content.prices[0].unit_amount
  //             standardprice = content.prices[1].unit_amount
  //           }

  //           this.setState({
  //             productCorrectPrice: this.state.user.has_subscription
  //               ? discountedprice
  //               : standardprice,
  //           })
  //         }
  //       })
  //   }
  // }

  // getStripeproductName = () => {
  //   const {planName} = this.props.match.params
  //   const {paidContent} = this.state

  //   if(planName){
  //     paidContent.forEach(content => {
  //       if(content.product_name == planName){

  //       }
  //     })
  //   }
  // }

  // live key: pk_live_51HWIlKBTktKoxCSowkBlpu6Hi3xDfKw7pkBjY71yLumHOpmpMZrvPKs3ZUdvq88bL5tiseSFo06dQm204yOZX8Mv003RH2NA19
  // test key: pk_test_51HWIlKBTktKoxCSoRq4oFh4PhDfrONqBfPhFRgorC9ytJ1BKCR13qFchCAJH47CDEg1IjQblrKgw4remQuDbuVZq00CowkNkLh
  onSelectSubscription = async (mode, e) => {
    const { stripeProductName } = this.state
    const planName = this.state.mode && this.state.mode

    if (!this.state.isUserCheckedLegalRegulationsChheckbox) {
      notify.show(
        `Proszę zaznaczyć pole wyboru świadczące o akceptacji polityki prywatności i regulaminu.`,
        'error',
        3000
      )
      this.setState({
        isUserReminded: true,
        isUserClickedButton: false,
      })
      return
    } else if (!this.state.isUserClickedButton) {
      this.setState({
        isUserClickedButton: true,
      })

      const stripePromise = await loadStripe(
        'pk_live_51HWIlKBTktKoxCSowkBlpu6Hi3xDfKw7pkBjY71yLumHOpmpMZrvPKs3ZUdvq88bL5tiseSFo06dQm204yOZX8Mv003RH2NA19'
      )
      let response

      if (
        mode == 'one' ||
        mode == 'three' ||
        mode == 'old-three' ||
        mode == 'nutshell2' ||
        mode == 'nutshell1'
      ) {
        response = await createUserPaymentSession(mode)
      } else {
        response = await createUserPaymentSession(mode, planName)
      }

      if (response == 204) {
        this.setState({
          showModal: true,
        })
      } else {
        let sessionId

        if (mode == 'nutshell1' || mode == 'nutshell2') {
          sessionId = response && (await response.data.id)
        } else {
          sessionId = response && (await response.id)
        }

        const stripe = await stripePromise

        if (sessionId) {
          const { error } = await stripe.redirectToCheckout({
            sessionId: sessionId,
          })
        }
      }
    } else {
      return
    }
  }

  onCheckLegalCheckbox = (event) => {
    // if (event.stopPropagation) {
    //   event.stopPropagation()
    // } else {
    //   event.cancelBubble = true
    // }

    this.setState({
      isUserCheckedLegalRegulationsChheckbox:
        !this.state.isUserCheckedLegalRegulationsChheckbox,
      isUserReminded: false,
    })
  }

  handleTryApp = () => {
    let exdate = new Date()
    exdate.setDate(exdate.getDate() + 365)

    cookie.save('userDemoMode', true, { path: '/', expires: exdate })
    setTimeout(() => {
      this.props.history.push('/redirect')
    }, 250)
  }

  changeMode = (mode) => {
    this.setState({
      mode: mode,
    })
  }

  setPromo = () => {
    this.setState({
      isPromoMode: true,
    })
  }

  render() {
    // return this.state.isPromoMode ? (
    //   <SelectPromoSubscriptionPlanScreen
    //     history={this.props.history}
    //     handleClick={this.handleClick}
    //     user={this.state.user}
    //     onSelectSubscription={this.onSelectSubscription}
    //     logout={this.logout}
    //     isUserClickedButton={this.state.isUserClickedButton}
    //     isUserCheckedLegalRegulationsChheckbox={
    //       this.state.isUserCheckedLegalRegulationsChheckbox
    //     }
    //     onCheckLegalCheckbox={this.onCheckLegalCheckbox}
    //     isUserReminded={this.state.isUserReminded}
    //     handleTryApp={this.handleTryApp}
    //     mode={this.state.mode}
    //     subInfo={this.state.subInfo}
    //     productCorrectPrice={this.state.productCorrectPrice}
    //     paidContent={this.state.paidContent}
    //     changeMode={this.changeMode}
    //     userBoughtPackages={this.state.userBoughtPackages}
    //     showModal={this.state.showModal}
    //   />
    // ) : (
    //   <SelectSubscriptionPlanScreen
    //     history={this.props.history}
    //     handleClick={this.handleClick}
    //     user={this.state.user}
    //     onSelectSubscription={this.onSelectSubscription}
    //     logout={this.logout}
    //     isUserClickedButton={this.state.isUserClickedButton}
    //     isUserCheckedLegalRegulationsChheckbox={
    //       this.state.isUserCheckedLegalRegulationsChheckbox
    //     }
    //     onCheckLegalCheckbox={this.onCheckLegalCheckbox}
    //     isUserReminded={this.state.isUserReminded}
    //     handleTryApp={this.handleTryApp}
    //     mode={this.state.mode}
    //     subInfo={this.state.subInfo}
    //     productCorrectPrice={this.state.productCorrectPrice}
    //     paidContent={this.state.paidContent}
    //     changeMode={this.changeMode}
    //     userBoughtPackages={this.state.userBoughtPackages}
    //     promoInfo={this.state.promoInfo}
    //     setPromo={this.setPromo}
    //   />
    // )

    return (
      <SelectSub
        isUserReminded={this.state.isUserReminded}
        isUserCheckedLegalRegulationsChheckbox={
          this.state.isUserCheckedLegalRegulationsChheckbox
        }
        onCheckLegalCheckbox={this.onCheckLegalCheckbox}
        onSelectSubscription={this.onSelectSubscription}
        history={this.props.history}
        handleTryApp={this.handleTryApp}
        mode={this.state.mode}
        promoInfo={this.state.promoInfo}
        isNutshell={
          this.props.location.state &&
          this.props.location.state.mode == 'w-pigulce'
            ? true
            : false
        }
        nutshellVersion={
          this.props.location.state && this.props.location.state.version
        }
      />
    )
  }
}

export default withRouter(SelectSubscriptionPlanScreenContainer)
